// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.VrmConfiguration in vrmConfig/vrmConfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * VRM/Custom endpoint configuration. Represents VRM/Custom endpoint configuration.
 */
public class VrmConfiguration(
  /**
   * General VRM config
   */
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val id: Int = 0,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val enabled: Boolean = false,
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "vrmType",
    schemaIndex = 2,
  )
  public val vrm_type: String = "",
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 3,
  )
  public val endpoint: String = "",
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "apiKey",
    schemaIndex = 4,
  )
  public val api_key: String = "",
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "siteId",
    schemaIndex = 5,
  )
  public val site_id: String = "",
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "bayIdentifier",
    schemaIndex = 6,
  )
  public val bay_identifier: String = "",
  @field:WireField(
    tag = 8,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "confidenceThreshold",
    schemaIndex = 7,
  )
  public val confidence_threshold: Float = 0f,
  @field:WireField(
    tag = 9,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "timeoutSeconds",
    schemaIndex = 8,
  )
  public val timeout_seconds: Int = 0,
  @field:WireField(
    tag = 10,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "verifySsl",
    schemaIndex = 9,
  )
  public val verify_ssl: Boolean = false,
  /**
   * Overlayer
   */
  @field:WireField(
    tag = 11,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enableOverlayer",
    schemaIndex = 10,
  )
  public val enable_overlayer: Boolean = false,
  @field:WireField(
    tag = 12,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "overlayerPositionIndex",
    schemaIndex = 11,
  )
  public val overlayer_position_index: Int = 0,
  @field:WireField(
    tag = 13,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "overlayerLabel",
    schemaIndex = 12,
  )
  public val overlayer_label: String = "",
  @field:WireField(
    tag = 14,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enableOverlayerOcrResults",
    schemaIndex = 13,
  )
  public val enable_overlayer_ocr_results: Boolean = false,
  @field:WireField(
    tag = 15,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enableOverlayerBayId",
    schemaIndex = 14,
  )
  public val enable_overlayer_bay_id: Boolean = false,
  @field:WireField(
    tag = 16,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enableOverlayerSiteId",
    schemaIndex = 15,
  )
  public val enable_overlayer_site_id: Boolean = false,
  @field:WireField(
    tag = 17,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "timeZone",
    schemaIndex = 16,
  )
  public val time_zone: String = "",
  /**
   * ROI/Bay-ID mapping. if set to true 'bay_identifier' should be ROI-ID or index, and should be used to filter
   * output. e.g. send VRM message only its bay_id and this config 'bay_identifier' are same. Else, treat
   * 'bay_identifier' as user-set field and send any VRM message to this endpoint.
   */
  @field:WireField(
    tag = 18,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "useRoiId",
    schemaIndex = 17,
  )
  public val use_roi_id: Boolean = false,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<VrmConfiguration, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is VrmConfiguration) return false
    if (unknownFields != other.unknownFields) return false
    if (id != other.id) return false
    if (enabled != other.enabled) return false
    if (vrm_type != other.vrm_type) return false
    if (endpoint != other.endpoint) return false
    if (api_key != other.api_key) return false
    if (site_id != other.site_id) return false
    if (bay_identifier != other.bay_identifier) return false
    if (confidence_threshold != other.confidence_threshold) return false
    if (timeout_seconds != other.timeout_seconds) return false
    if (verify_ssl != other.verify_ssl) return false
    if (enable_overlayer != other.enable_overlayer) return false
    if (overlayer_position_index != other.overlayer_position_index) return false
    if (overlayer_label != other.overlayer_label) return false
    if (enable_overlayer_ocr_results != other.enable_overlayer_ocr_results) return false
    if (enable_overlayer_bay_id != other.enable_overlayer_bay_id) return false
    if (enable_overlayer_site_id != other.enable_overlayer_site_id) return false
    if (time_zone != other.time_zone) return false
    if (use_roi_id != other.use_roi_id) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + id.hashCode()
      result = result * 37 + enabled.hashCode()
      result = result * 37 + vrm_type.hashCode()
      result = result * 37 + endpoint.hashCode()
      result = result * 37 + api_key.hashCode()
      result = result * 37 + site_id.hashCode()
      result = result * 37 + bay_identifier.hashCode()
      result = result * 37 + confidence_threshold.hashCode()
      result = result * 37 + timeout_seconds.hashCode()
      result = result * 37 + verify_ssl.hashCode()
      result = result * 37 + enable_overlayer.hashCode()
      result = result * 37 + overlayer_position_index.hashCode()
      result = result * 37 + overlayer_label.hashCode()
      result = result * 37 + enable_overlayer_ocr_results.hashCode()
      result = result * 37 + enable_overlayer_bay_id.hashCode()
      result = result * 37 + enable_overlayer_site_id.hashCode()
      result = result * 37 + time_zone.hashCode()
      result = result * 37 + use_roi_id.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """id=$id"""
    result += """enabled=$enabled"""
    result += """vrm_type=${sanitize(vrm_type)}"""
    result += """endpoint=${sanitize(endpoint)}"""
    result += """api_key=${sanitize(api_key)}"""
    result += """site_id=${sanitize(site_id)}"""
    result += """bay_identifier=${sanitize(bay_identifier)}"""
    result += """confidence_threshold=$confidence_threshold"""
    result += """timeout_seconds=$timeout_seconds"""
    result += """verify_ssl=$verify_ssl"""
    result += """enable_overlayer=$enable_overlayer"""
    result += """overlayer_position_index=$overlayer_position_index"""
    result += """overlayer_label=${sanitize(overlayer_label)}"""
    result += """enable_overlayer_ocr_results=$enable_overlayer_ocr_results"""
    result += """enable_overlayer_bay_id=$enable_overlayer_bay_id"""
    result += """enable_overlayer_site_id=$enable_overlayer_site_id"""
    result += """time_zone=${sanitize(time_zone)}"""
    result += """use_roi_id=$use_roi_id"""
    return result.joinToString(prefix = "VrmConfiguration{", separator = ", ", postfix = "}")
  }

  public fun copy(
    id: Int = this.id,
    enabled: Boolean = this.enabled,
    vrm_type: String = this.vrm_type,
    endpoint: String = this.endpoint,
    api_key: String = this.api_key,
    site_id: String = this.site_id,
    bay_identifier: String = this.bay_identifier,
    confidence_threshold: Float = this.confidence_threshold,
    timeout_seconds: Int = this.timeout_seconds,
    verify_ssl: Boolean = this.verify_ssl,
    enable_overlayer: Boolean = this.enable_overlayer,
    overlayer_position_index: Int = this.overlayer_position_index,
    overlayer_label: String = this.overlayer_label,
    enable_overlayer_ocr_results: Boolean = this.enable_overlayer_ocr_results,
    enable_overlayer_bay_id: Boolean = this.enable_overlayer_bay_id,
    enable_overlayer_site_id: Boolean = this.enable_overlayer_site_id,
    time_zone: String = this.time_zone,
    use_roi_id: Boolean = this.use_roi_id,
    unknownFields: ByteString = this.unknownFields,
  ): VrmConfiguration = VrmConfiguration(id, enabled, vrm_type, endpoint, api_key, site_id, bay_identifier, confidence_threshold, timeout_seconds, verify_ssl, enable_overlayer, overlayer_position_index, overlayer_label, enable_overlayer_ocr_results, enable_overlayer_bay_id, enable_overlayer_site_id, time_zone, use_roi_id, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<VrmConfiguration> = object : ProtoAdapter<VrmConfiguration>(
      FieldEncoding.LENGTH_DELIMITED, 
      VrmConfiguration::class, 
      "type.googleapis.com/vreo.volt.protocol.VrmConfiguration", 
      PROTO_3, 
      null, 
      "vrmConfig/vrmConfig.proto"
    ) {
      override fun encodedSize(`value`: VrmConfiguration): Int {
        var size = value.unknownFields.size
        if (value.id != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.id)
        }
        if (value.enabled != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(2, value.enabled)
        }
        if (value.vrm_type != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(3, value.vrm_type)
        }
        if (value.endpoint != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(4, value.endpoint)
        }
        if (value.api_key != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(5, value.api_key)
        }
        if (value.site_id != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(6, value.site_id)
        }
        if (value.bay_identifier != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(7, value.bay_identifier)
        }
        if (!value.confidence_threshold.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(8, value.confidence_threshold)
        }
        if (value.timeout_seconds != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(9, value.timeout_seconds)
        }
        if (value.verify_ssl != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(10, value.verify_ssl)
        }
        if (value.enable_overlayer != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(11, value.enable_overlayer)
        }
        if (value.overlayer_position_index != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(12, value.overlayer_position_index)
        }
        if (value.overlayer_label != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(13, value.overlayer_label)
        }
        if (value.enable_overlayer_ocr_results != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(14, value.enable_overlayer_ocr_results)
        }
        if (value.enable_overlayer_bay_id != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(15, value.enable_overlayer_bay_id)
        }
        if (value.enable_overlayer_site_id != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(16, value.enable_overlayer_site_id)
        }
        if (value.time_zone != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(17, value.time_zone)
        }
        if (value.use_roi_id != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(18, value.use_roi_id)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: VrmConfiguration) {
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
        if (value.enabled != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enabled)
        }
        if (value.vrm_type != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.vrm_type)
        }
        if (value.endpoint != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.endpoint)
        }
        if (value.api_key != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.api_key)
        }
        if (value.site_id != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.site_id)
        }
        if (value.bay_identifier != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 7, value.bay_identifier)
        }
        if (!value.confidence_threshold.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 8, value.confidence_threshold)
        }
        if (value.timeout_seconds != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 9, value.timeout_seconds)
        }
        if (value.verify_ssl != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 10, value.verify_ssl)
        }
        if (value.enable_overlayer != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 11, value.enable_overlayer)
        }
        if (value.overlayer_position_index != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 12, value.overlayer_position_index)
        }
        if (value.overlayer_label != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 13, value.overlayer_label)
        }
        if (value.enable_overlayer_ocr_results != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 14, value.enable_overlayer_ocr_results)
        }
        if (value.enable_overlayer_bay_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 15, value.enable_overlayer_bay_id)
        }
        if (value.enable_overlayer_site_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 16, value.enable_overlayer_site_id)
        }
        if (value.time_zone != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 17, value.time_zone)
        }
        if (value.use_roi_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 18, value.use_roi_id)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: VrmConfiguration) {
        writer.writeBytes(value.unknownFields)
        if (value.use_roi_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 18, value.use_roi_id)
        }
        if (value.time_zone != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 17, value.time_zone)
        }
        if (value.enable_overlayer_site_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 16, value.enable_overlayer_site_id)
        }
        if (value.enable_overlayer_bay_id != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 15, value.enable_overlayer_bay_id)
        }
        if (value.enable_overlayer_ocr_results != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 14, value.enable_overlayer_ocr_results)
        }
        if (value.overlayer_label != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 13, value.overlayer_label)
        }
        if (value.overlayer_position_index != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 12, value.overlayer_position_index)
        }
        if (value.enable_overlayer != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 11, value.enable_overlayer)
        }
        if (value.verify_ssl != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 10, value.verify_ssl)
        }
        if (value.timeout_seconds != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 9, value.timeout_seconds)
        }
        if (!value.confidence_threshold.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 8, value.confidence_threshold)
        }
        if (value.bay_identifier != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 7, value.bay_identifier)
        }
        if (value.site_id != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.site_id)
        }
        if (value.api_key != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.api_key)
        }
        if (value.endpoint != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.endpoint)
        }
        if (value.vrm_type != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.vrm_type)
        }
        if (value.enabled != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 2, value.enabled)
        }
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
      }

      override fun decode(reader: ProtoReader): VrmConfiguration {
        var id: Int = 0
        var enabled: Boolean = false
        var vrm_type: String = ""
        var endpoint: String = ""
        var api_key: String = ""
        var site_id: String = ""
        var bay_identifier: String = ""
        var confidence_threshold: Float = 0f
        var timeout_seconds: Int = 0
        var verify_ssl: Boolean = false
        var enable_overlayer: Boolean = false
        var overlayer_position_index: Int = 0
        var overlayer_label: String = ""
        var enable_overlayer_ocr_results: Boolean = false
        var enable_overlayer_bay_id: Boolean = false
        var enable_overlayer_site_id: Boolean = false
        var time_zone: String = ""
        var use_roi_id: Boolean = false
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> id = ProtoAdapter.INT32.decode(reader)
            2 -> enabled = ProtoAdapter.BOOL.decode(reader)
            3 -> vrm_type = ProtoAdapter.STRING.decode(reader)
            4 -> endpoint = ProtoAdapter.STRING.decode(reader)
            5 -> api_key = ProtoAdapter.STRING.decode(reader)
            6 -> site_id = ProtoAdapter.STRING.decode(reader)
            7 -> bay_identifier = ProtoAdapter.STRING.decode(reader)
            8 -> confidence_threshold = ProtoAdapter.FLOAT.decode(reader)
            9 -> timeout_seconds = ProtoAdapter.INT32.decode(reader)
            10 -> verify_ssl = ProtoAdapter.BOOL.decode(reader)
            11 -> enable_overlayer = ProtoAdapter.BOOL.decode(reader)
            12 -> overlayer_position_index = ProtoAdapter.INT32.decode(reader)
            13 -> overlayer_label = ProtoAdapter.STRING.decode(reader)
            14 -> enable_overlayer_ocr_results = ProtoAdapter.BOOL.decode(reader)
            15 -> enable_overlayer_bay_id = ProtoAdapter.BOOL.decode(reader)
            16 -> enable_overlayer_site_id = ProtoAdapter.BOOL.decode(reader)
            17 -> time_zone = ProtoAdapter.STRING.decode(reader)
            18 -> use_roi_id = ProtoAdapter.BOOL.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return VrmConfiguration(
          id = id,
          enabled = enabled,
          vrm_type = vrm_type,
          endpoint = endpoint,
          api_key = api_key,
          site_id = site_id,
          bay_identifier = bay_identifier,
          confidence_threshold = confidence_threshold,
          timeout_seconds = timeout_seconds,
          verify_ssl = verify_ssl,
          enable_overlayer = enable_overlayer,
          overlayer_position_index = overlayer_position_index,
          overlayer_label = overlayer_label,
          enable_overlayer_ocr_results = enable_overlayer_ocr_results,
          enable_overlayer_bay_id = enable_overlayer_bay_id,
          enable_overlayer_site_id = enable_overlayer_site_id,
          time_zone = time_zone,
          use_roi_id = use_roi_id,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: VrmConfiguration): VrmConfiguration = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
